import { reactive } from 'vue';

export const store = reactive({
  formGerais: {},
  formObjeto: {},
  formServicos: {},
  formPagamentos: {},
  formObservacoes: {},
  dataFetching: {
    servicos: true,
  },
});
